"use strict";
/**
 * @module Services.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A security role
 */
var RoleImpl = /** @class */ (function () {
    /**
     * Create a new Role instance
     *
     * @param name  the name of the role
     * @param global  the global permissions of the role
     * @param defaultPermissions  the default path permissions of the role
     * @param path  the path permissions indexed by topic path
     * @param roles  additional roles
     */
    function RoleImpl(name, global, defaultPermissions, path, roles, lockingPrincipal) {
        this.name = name;
        this.global = global;
        this.default = defaultPermissions;
        this.topic = path;
        this.roles = roles;
        this.lockingPrincipal = lockingPrincipal;
    }
    return RoleImpl;
}());
exports.RoleImpl = RoleImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/role.js
// module id = 1977
// module chunks = 1